// extracted by mini-css-extract-plugin
export var chatHtmlText = "_qz-2";
export var chatLink = "_qz-0";
export var chatText = "_qz-1";